export const programs = {
  title: 'Ипотечные программы с господдержкой',
  elements: [
    {
      name: 'Семейная ипотека',
      rate: 'От 2% до 12% в зависимости от количества детей и региона',
      whoCanGet: 'Семьи, в которых есть хотя бы один ребёнок младше 7 лет на дату заключения кредитного договора',
      creditFor:
        'Строящееся или готовое жильё, строительство жилого дома с помощью подрядчика с использованием эскроу-счёта. Для ИЖС ставка остаётся 6% независимо от количества детей и региона',
      conditions:
        'Первоначальный взнос от 20%; банк вправе установить больший процент. Лимит до 10 млн ₽ в регионах / до 18 млн ₽ в Москве, МО, Санкт-Петербурге и ЛО. Государственное субсидирование льготной ставки ограничивается 15 годами. Одна семья — одна льготная ипотека',
    },
    {
      name: 'Дальневосточная и арктическая ипотека',
      rate: 'До 2%',
      whoCanGet:
        'Молодые семьи и одинокие родители, живущие в этих регионах, а также работники определенных социальных групп',
      creditFor: 'Приобретение жилья от застройщика, строительство дома, вторичное жилье в некоторых регионах',
      conditions: 'Заключение договора до конца 2030 года, есть ограничение по сумме кредита',
    },
    {
      name: 'Сельская ипотека',
      rate: 'От 0,1 до 3%',
      whoCanGet: 'Граждане РФ',
      creditFor: 'Покупка или строительство жилья в сельской местности',
      conditions: 'Срок до 25 лет, сумма кредита до 6–9 млн ₽',
    },
  ],
};
